<template>
  <div class="home">
    <KV/>
    <Present/>
      <Login :checkLogout="checkLogout"/>
      <Learning/>
      <Notice/>
<!--      <NoticeQ4/>-->
      <QA/>
  </div>
</template>

<script setup>
import KV from "@/components/kv.vue";
import Present from "@/components/present.vue";
import Login from "@/components/login.vue";
import Learning from "@/components/learning.vue";
import Notice from "@/components/Notice.vue";
// import NoticeQ4 from "@/components/NoticeQ4.vue";
import QA from "@/components/QA.vue";
import {ref ,watch} from "vue";

// 定義 props
const props = defineProps({
    checkLogout: Boolean,
});
const checkLogout = ref(false);
watch(() => props.checkLogout, (newVal) => {
    checkLogout.value = newVal;
});
</script>




